import { AttributesMixin, define, Model } from "@type-r/models";
import { restfulIO } from "./endpoint";

export interface AssetEventFailureMessagesCount extends AttributesMixin<typeof AssetEventFailureMessagesCount> { }
@define
export class AssetEventFailureMessagesCount extends Model {
    static endpoint = restfulIO('/api/v1/assetmaster/assetsEvents/failure-message-count/');

    static attributes = {
        importJobId: Number,
        eventTypeId: Number,
        message: String,
        count: Number
    };
}
